import { SpecificationCoverageDto } from "src/app/models/dto/specificationCoverageDto";
import { SpecificationCoverageInput } from "../models/input/graphql-specification-coverage-inputs";
import { convertPolarionRequirementToGraphQlInput, convertSpecificationToGraphQlInput } from "./test-analysis.mappers";

export function convertSpecificationCoverageDtoToGraphqlInput(input: SpecificationCoverageDto): SpecificationCoverageInput {
    if(!input) return undefined;

    return {
        Uid: input.uid ?? '',
        ItemNo: input.itemNo,
        Name: input.name,
        Version: input.version,
        ModifiedBy: input.modifiedBy,
        ModificationTime: null,
        Comment: input.comment,
        LockedBy: input.lockedBy,
        LockedTime: null,
        CreatedBy: input.createdBy,
        CreationTime: null,
        ApprovalStatus: input.approvalStatus,
        ApprovedForTestLevel: input.approvedForTestLevel,
        Specifications: input.specifications?.map(item =>{
          return convertSpecificationToGraphQlInput(item);
        }) ?? [],
        Requirements: input.requirements?.map(item => {
          return convertPolarionRequirementToGraphQlInput(item);
        }) ?? [],
        Tags: input.tags,
    }
  }
